import { render, staticRenderFns } from "./MrpTypes.vue?vue&type=template&id=488b6c4a"
import script from "./MrpTypes.vue?vue&type=script&lang=js"
export * from "./MrpTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports